import styled from "styled-components";
import Icon from "../Icon/Icon";
import { TooltipTrigger } from "../Tooltip/Tooltip";

interface ListItemProps {
  $extended: boolean;
  $isReadOnly: boolean;
  selected: boolean;
}

interface TrackingNumberProps {
  $trackNumberColor: string;
}

export const ListWrapper = styled.ul`
  padding: 0;
  margin: 4px 0 0 0;
  width: 100%;
`;

export const ListItem = styled.li<ListItemProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  width: 100%;

  ${({ $extended, theme }) =>
    $extended
      ? `border-bottom: 1px solid ${theme.whiteSmoke};`
      : `pointer-events: none;`}

  ${({ selected, $isReadOnly, theme }) =>
    selected &&
    !$isReadOnly &&
    `
    background-color: ${theme.primary10};
    border: none;
  `}

  & > div {
    ${({ $isReadOnly }) =>
      $isReadOnly &&
      `
    cursor: default;
  `}
  }
`;

export const ItemContent = styled.div`
  padding: 12px 5px 12px 8px;
  width: 100%;
  cursor: pointer;
`;

export const ItemName = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ItemQuantity = styled.div`
  margin-left: auto;
`;

export const TrackingNumber = styled.div<TrackingNumberProps>`
  margin: 0 0 0 4px;
  line-height: 18px;
  word-break: break-word;
  color: ${({ $trackNumberColor }) => $trackNumberColor};
`;

export const Comment = styled.p`
  margin: 2px 0 0 30px;
  font-size: 12px;
  width: max-content;
  color: ${({ theme }) => theme.black50};
  background-color: ${({ theme }) => theme.whiteSmoke};
  padding: 2px 6px;
  border-radius: 2px;
`;

export const DetailedButton = styled("div")`
  display: flex;
  padding: 0;
  width: 100%;

  &:hover {
    opacity: 0.8;
  }
`;

export const RightArrowIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.grey75};
  transition: opacity 0.2s;
`;

export const AddonIcons = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  flex-shrink: 0;

  & > ${TooltipTrigger} {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    line-height: 0;
  }

  img {
    display: block;
    margin: 0;
  }
`;

export const ServiceRequests = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const OpenItemWrapper = styled.div`
  padding: 14px 5px 14px 15px;
  cursor: pointer;
`;
